<template>
  <main class="ap-page">
    <!-- HERO -->
    <header class="ap-hero">
      <div class="ap-hero-inner">
        <div class="ap-underLogoPhrase">
          <h1 class="font-weight-bold mb-4 centers">
            <span class="marker">{{ pageTitle }}</span>
          </h1>
        </div>
      </div>
    </header>

    <!-- CONTENT -->
    <section class="ap-content">
      <!-- FILTRES -->
      <div class="animal-filters mb-4">
        <div class="filter-row">
     

          <label>Sexe
            <select v-model="filtres.sexe">
              <option value="">Tous</option>
              <option value="Mâle">Mâle</option>
              <option value="Femelle">Femelle</option>
            </select>
          </label>

          <label>Couleur
            <select v-model="filtres.couleur">
              <option value="">Toutes</option>
              <option
                v-for="c in optionsCouleur"
                :key="c"
                :value="c"
              >{{ String(c) }}</option>
            </select>
          </label>

      

          <label>Âge
            <select v-model="filtres.age">
              <option value="">Tous</option>
              <option value="bebe">Chiots (&lt;6 mois)</option>
              <option value="ado">Ados (6-24 mois)</option>
              <option value="adulte">Adultes (&gt;24 mois)</option>
            </select>
          </label>

          <button class="btn-reset" @click="resetFiltres" type="button">Réinitialiser</button>
        </div>
      </div>

      <!-- GRID -->
      <div class="grid">
        <router-link
          v-for="animau in animauxFiltres"
          :key="animau.id"
          :to="'/animaux/' + animau.id"
          class="card-link"
        >
          <div class="animal-card">
            <div class="animal-image">
              <img
                :src="getImage(animau)"
                :alt="getSafeAlt(animau)"
                loading="lazy"
              />
            </div>
            <div class="animal-info">
              <h5 class="animal-name">
                {{ getSafeName(animau) }}
                <span class="animal-icon">{{ animau.type === 'chat' ? '🐱' : '🐶' }}</span>
              </h5>
              <p class="animal-detail"><strong>Âge :</strong> {{ calculateAge(animau.naissance) }}</p>
              <p class="animal-detail"><strong>Race :</strong> {{ getSafeRace(animau) }}</p>
              <p class="animal-detail" v-if="animau.huge_information">
                <strong style="color:red">{{ getSafeHugeInfo(animau) }}</strong>
              </p>
            </div>
          </div>
        </router-link>
      </div>
    </section>
  </main>
</template>

<script>
import convertAge from "../components/getAge.js";

export default {
  data() {
    return {
      animaux: [],
      anges: [],
      lastUpdateChien: null,
      lastUpdateChat: null,
      filtres: {
        type: "",
        sexe: "",
        couleur: "",
        age: "",
        ville: ""
      }
    };
  },

  computed: {
    pageTitle() {
      let title = "Les animaux à adopter";
      if (this.filtres.type) {
        switch (this.filtres.type) {
          case 'chien': title = "Les chiens à adopter"; break;
          case 'chat': title = "Les chats à adopter"; break;
          case 'chiot': title = "Les chiots à adopter"; break;
          case 'chaton': title = "Les chatons à adopter"; break;
          case 'nacs': title = "Les NACs à adopter"; break;
          case 'anges': title = "Nos anges"; break;
        }
      }
      return title;
    },
    optionsCouleur() {
      return [...new Set(this.animaux.filter(a => a.couleur).map(a => a.couleur))].sort();
    },
    optionsVille() {
      return [...new Set(this.animaux.filter(a => a.ville).map(a => a.ville))].sort();
    },

    animauxFiltres() {
      const { type, sexe, couleur, age, ville } = this.filtres;

      let baseAnimaux = this.animaux;
      if (type === 'anges') {
        baseAnimaux = this.anges;
      }

      return baseAnimaux
        .filter(animal => {
          if (type) {
            if (type === 'chiot') {
              if (animal.type !== 'chien' || !animal.naissance || this.ageEnMois(animal.naissance) >= 10) return false;
            } else if (type === 'chaton') {
              if (animal.type !== 'chat' || !animal.naissance || this.ageEnMois(animal.naissance) >= 10) return false;
            } else if (type === 'anges') {
              // Already filtered by API
            } else if (animal.type !== type) return false;
          }
          if (sexe && this.normalizeSex(animal.sexe) !== this.normalizeSex(sexe)) return false;
          if (couleur && animal.couleur !== couleur) return false;
          if (ville && animal.ville !== ville) return false;

          if (age) {
            const mois = this.ageEnMois(animal.naissance);
            if (age === "bebe" && mois >= 6) return false;
            if (age === "ado" && (mois < 6 || mois > 24)) return false;
            if (age === "adulte" && mois <= 24) return false;
          }

          return true;
        })
        .sort((a, b) => {
          const da = a.created_at ? new Date(a.created_at) : new Date(0);
          const db = b.created_at ? new Date(b.created_at) : new Date(0);
          return db - da;
        });
    }
  },

  watch: {
    "$route.query.type": {
      immediate: true,
      handler(type) {
        this.filtres.type = type || "";
      }
    }
  },

  mounted() {
    const idSite = this.$idSite;

    fetch(`https://admin.asso-refuge.fr/getAnimal/${idSite}`)
      .then(res => res.json())
      .then(data => {
        this.animaux = Array.isArray(data) ? data : [];
        this.calculerDernieresMAJ();
      })
      .catch(err => console.error("Erreur chargement animaux :", err));

    fetch(`https://admin.asso-refuge.fr/getAnimalMort/${idSite}`)
      .then(res => res.json())
      .then(data => {
        this.anges = Array.isArray(data) ? data : [];
      })
      .catch(err => console.error("Erreur chargement anges :", err));
  },

  methods: {
    resetFiltres() {
      this.filtres = {
        type: this.$route.query.type || "",
        sexe: "",
        couleur: "",
        age: "",
        ville: ""
      };
    },

    normalizeSex(sexe) {
      const s = String(sexe ?? "").toLowerCase();
      if (s === "female" || s === "femelle" || s === "f") return "Femelle";
      if (s === "male" || s === "mâle" || s === "m") return "Mâle";
      return sexe || "";
    },

    calculateAge(dateOfBirth) {
      return convertAge(dateOfBirth);
    },

    getImage(animal) {
      if (animal.img1) return 'https://admin.asso-refuge.fr/images/' + animal.img1;
      return animal.type === 'chat'
        ? 'https://www.admin.spadesavoie.fr/images/chatmanquant.png'
        : 'https://www.admin.spadesavoie.fr/images/chienmanquant.png';
    },

    getSafeName(animal) {
      return String(animal.name || "—");
    },

    getSafeRace(animal) {
      return String(animal.race || "");
    },

    getSafeHugeInfo(animal) {
      return String(animal.huge_information || "");
    },

    getSafeAlt(animal) {
      return String(animal.type || "") + ' ' + String(animal.name || "");
    },

    ageEnMois(dateOfBirth) {
      if (!dateOfBirth) return 0;
      const birth = new Date(dateOfBirth);
      const now = new Date();
      return (now.getFullYear() - birth.getFullYear()) * 12 + (now.getMonth() - birth.getMonth());
    },

    calculerDernieresMAJ() {
      const maxDate = arr =>
        arr.reduce((a, b) =>
          new Date(a.created_at) > new Date(b.created_at) ? a : b
        );

      const chiens = this.animaux.filter(a => a.type === "chien");
      const chats = this.animaux.filter(a => a.type === "chat");

      this.lastUpdateChien = chiens.length ? maxDate(chiens).created_at : null;
      this.lastUpdateChat = chats.length ? maxDate(chats).created_at : null;
    },

    formatDate(dateStr) {
      if (!dateStr) return "";
      const d = new Date(dateStr);
      return d.toLocaleDateString("fr-FR", { year: "numeric", month: "short", day: "2-digit" });
    }
  }
};
</script>

<style scoped src="../assets/css/animauxnew.css"></style>

